<template>
	<div
		class="ry-form__table-item"
		:style="rowStyle"
	>
		<van-row>
			<van-col span="12">
				<van-tag
					mark
					type="primary"
					color="#4260FA"
				>
					&nbsp;&nbsp;{{index + 1}}&nbsp;&nbsp;
				</van-tag>
			</van-col>
			<van-col
				class="table-item__handle"
				span="12"
			>
				<van-button
					v-if="!isRead && (!this.current.closeTableCreate || !this.current.closeTableDelete)"
					color="#4260FA"
					plain
					@click="showMore = true"
					size="mini"
				>
					更多
				</van-button>
				<van-button
					color="#4260FA"
					@click="currentShow = !currentShow"
					size="mini"
				>
					{{currentShow? '收起':'展开'}}
				</van-button>
			</van-col>
		</van-row>

		<van-action-sheet
			v-model="showMore"
			:actions="actions"
			cancel-text="取消"
			close-on-click-action
			get-container="body"
			@select="handleSelect"
		/>
		<div
			v-show="currentShow"
			v-enterToNext="true"
		>
			<div
				class="table-field-item"
				v-for="item in header"
				v-if="isShow(item)"
				:key="item.dataId"
				:style="tableFieldItemStyle(item)"
			>
				<component
					:is="'table_' + item.type"
					:row="row"
					:index="index"
					:value="item"
					:type="status"
				>
				</component>
				<!--自定义样式提示文字-->
				<div
					v-if="row.rowCustom[item.dataId].showCustom"
					class="table-field-tips-text"
					:style="{color: row.rowCustom[item.dataId].color === '#ffffff' ? '#909399' : current.errInfo && current.errInfo.idList && current.errInfo.idList.includes(row.id) ? '#f55d54' : '#ffffff'}"
				>
					{{row.rowCustom[item.dataId].alertMsg}}
				</div>
			</div>
		</div>
		<div
			class="ry-form__table-item-placeholder"
			v-show="!currentShow"
		>
			{{allValue}}
		</div>
	</div>
</template>

<script>
	import TableControl from './index'
	import {
		FORM_ITEM__DEPARTMENT,
		FORM_ITEM__MEMBER,
		FORM_ITEM__SIGNATURE,
		FORM_STATUS__FILL,
		PERMISSION__HIDDEN
	} from "../../types"
	import {
		uuid
	} from "../../utils";

	export default {
		props: {
			header: Array,
			row: Object,
			current: Object,
			index: Number,
			length: Number,
			isRead: {
				type: Boolean,
				default: false
			},
			showList: {
				type: Array,
				default: () => []
			},
			status: {
				type: Number,
				default: FORM_STATUS__FILL
			},
			controlChange: Function
		},
		data() {
			return {
				showMore: false,
			}
		},
		computed: {
			currentShow: {
				get() {
					return this.showList.includes(this.row.id)
				},
				set(bol) {
					if (bol) {
						this.showList.push(this.row.id)
					} else {
						const idx = this.showList.indexOf(this.row.id)
						this.showList.splice(idx, 1)
					}
				}
			},
			allValue() {
				let s = ''
				if (this.current) {
					const currentValue = this.current.value[this.index]
					this.current.children.forEach(item => {
						if (item && item.valueToString && !(item.permission === PERMISSION__HIDDEN || item
								.hidden === 1 || item.followHidden || !item.displayInfo.show)) {
							if (item.type === FORM_ITEM__MEMBER ||
								item.type === FORM_ITEM__DEPARTMENT) {
								const opts = {
									depList: this.$store.getters.depListMap,
									roleList: this.$store.getters.roleListMap,
									userList: this.$store.getters.userListMap
								}
								if (item.valueToString(null, opts)) {
									s += `${item.valueToString(currentValue[item.dataId], opts)} | `
								} else {
									s += ' _ |'
								}
							} else if (item.type === FORM_ITEM__SIGNATURE) {

							} else {
								if (item.valueToString(currentValue[item.dataId])) {
									s += `${item.valueToString(currentValue[item.dataId])} | `
								} else {
									s += ' _ |'
								}
							}
						}
					})
				}
				return s || ' _ | _ | _'
			},
			rowStyle() {
				console.log('errInfo', this.current.errInfo, this.row)
				if (this.current.errInfo && this.current.errInfo.idList) {
					if (this.current.errInfo.idList.includes(this.row.id)) {
						return {
							backgroundColor: '#FEF4D9'
						}
					}
				}
				return {
					backgroundColor: '#ffffff'
				}
			},

			actions() {
				const arr = []
				if (!this.isRead && !this.current.closeTableCreate) {
					arr.push(...[{
							name: '复制到上一行'
						},
						{
							name: '复制到下一行'
						},
						{
							name: '复制到最后一行'
						},
						{
							name: '向上插入行'
						},
						{
							name: '向下插入行'
						}
					])
				}
				if (!this.isRead && !this.current.closeTableDelete) {
					arr.push({
						name: '删除',
						color: '#f55d54'
					})
				}
				return arr
			}
		},
		methods: {
			tableFieldItemStyle(item) {
				let color = '#fff'
				if (item && this.row && this.row.rowCustom && this.row.rowCustom[item.dataId]) {
					if (this.current.errInfo && this.current.errInfo.idList && this.current.errInfo.idList.includes(this
							.row.id)) {
						color = 'transparent'
					} else {
						color = this.row.rowCustom[item.dataId].showCustom ? this.row.rowCustom[item.dataId].color : '#fff'
					}
				}
				return {
					backgroundColor: color
				}
			},
			removeItem() {
				this.$dialog.confirm({
					title: '确认信息',
					message: '是否确认删除这条记录？',
					beforeClose: (action, done) => {
						if (action === 'confirm') {
							this.$emit('removeItem', this.index)
						}
						done()
					}
				})
			},
			isShow(field) {
				return !(field.permission === PERMISSION__HIDDEN || field.hidden === 1 || !field.displayInfo.show)
			},

			handleSelect(action, index) {

				if (action.name === '复制到上一行') {
					this.copyAboveRow()
				} else if (action.name === '复制到下一行') {
					this.copyNextRow()
				} else if (action.name === '复制到最后一行') {
					this.copyLastRow()
				} else if (action.name === '向上插入行') {
					this.installAboveRow()
				} else if (action.name === '向下插入行') {
					this.installNextRow()
				} else if (action.name === '删除') {
					this.removeItem()
				}

				this.showMore = false
			},
			copyAboveRow() {
				const copyItem = {}
				Object.keys(this.row).forEach(key => {
					this.$set(copyItem, key, this.clone(this.row[key]))
				})
				const id = uuid('tb')
				copyItem.id = id
				copyItem.newId = id
				if (this.index === 0) {
					this.current.value.unshift(copyItem)
				} else {
					this.current.value.splice(this.index + 1, 0, copyItem)
				}
				this.controlChange()
			},
			copyNextRow() {
				const copyItem = {}
				Object.keys(this.row).forEach(key => {
					this.$set(copyItem, key, this.clone(this.row[key]))
				})
				const id = uuid('tb')
				copyItem.id = id
				copyItem.newId = id
				this.current.value.splice(this.index + 1, 0, copyItem)
				this.controlChange()
			},
			copyLastRow() {
				const copyItem = {}
				Object.keys(this.row).forEach(key => {
					this.$set(copyItem, key, this.clone(this.row[key]))
				})
				const id = uuid('tb')
				copyItem.id = id
				copyItem.newId = id
				this.current.value.push(copyItem)
				this.controlChange()
			},
			installAboveRow() {
				if (this.index === 0) {
					this.current.addRowToIndex(0)
				} else {
					this.current.addRowToIndex(this.index)
				}
				this.controlChange()
			},
			installNextRow() {
				this.current.addRowToIndex(this.index + 1)
				this.controlChange()
			},
			clone(obj) {
				if (obj) return JSON.parse(JSON.stringify(obj))
				return obj
			},
		},
		components: {
			...TableControl
		},
		watch: {}
	}
</script>

<style lang="less">
	.ry-form__table-item {
		margin-bottom: 16px;

		.ry-form__table-item-placeholder {
			word-break: break-word;
			margin-top: 6px;
		}

		.table-item__handle {
			.van-button {
				float: right;
				margin-left: 6px;
				padding: 0 6px;
			}
		}

		.table-field-item {
			position: relative;

			.table-field-tips-text {
				font-size: 12px;
				color: #fff;
				line-height: 14px;
				margin: -10px 0 0 16px;
			}

			&:after {
				position: absolute;
				box-sizing: border-box;
				content: ' ';
				pointer-events: none;
				right: 0;
				bottom: 0;
				left: 0;
				border-bottom: 1px solid #ebedf0;
				transform: scaleY(0.5);
			}
		}
	}
</style>
